import { render, staticRenderFns } from "./home.vue?vue&type=template&id=f8500f8c&scoped=true&lang=pug&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=f8500f8c&prod&lang=sass&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=f8500f8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8500f8c",
  null
  
)

export default component.exports